export default {
	global: {
		appVersion: '1.14.0',
		appDefaultEntryPoint: 'home',
		baseUrl: '/es.mmpp.MMPP',
		appDistribution: null
	},
	menu: {
		keepExpanded: true,
		searchBtn: false,
		notificationsBtn: false,
		helpBtn: false,
		breadcrumbItems: null
	},
	form: {
		showSaveAndUpdate: true,
		showSaveAndNew: true
	}
};
